import React, { useState } from 'react'
import DateTimePicker from '../../../ReusableComponents/DateTimePicker';
import { GLOBAL_STYLES, INDIAN_STATES } from '../../../appConstants';
import { Button } from '../../../Components/Helper';
import Modal from '../../../ReusableComponents/Modal';
import Filter from "../../../assets/filter.svg";
import LoaderComponent from '../../../ReusableComponents/LoaderComponent';
import SingleFilter from '../../../features/MyRequests/SubComponents/FilterRequest/SingleFilter';
import Popup from '../../../ReusableFunctions/Popup';

const UsersFilter = ({ filter, onFilterChange, open, onClose, setOpenFilter, loading }) => {
    const [usersFilter, setUsersFilter] = useState(filter);
    const [searchQuery, setSearchQuery] = useState("");

    const handleFilterChange = (updatedFilter) => {
        setUsersFilter(updatedFilter);
    };

    const handleOnChangeState = (e) => {
        const value = e.target.value;
        let newStates = usersFilter.states;
        if (e.target.checked) {
          if (newStates?.length < 3) {
            newStates = [...newStates, value];
          } else {
            Popup.alert("WARNING", 'You can only select up to 3 states at time', 'ERROR')
            return;
          }
        } else {
          newStates = newStates.filter((status) => status !== value);
        }
        newStates = Array.from(new Set(newStates));
        setUsersFilter((prev) => ({
          ...prev,
          states: newStates
        }));
      };

    function toLocalISOString(date) {
        const offset = date.getTimezoneOffset(); // Timezone offset in minutes
        const localTime = new Date(date.getTime() - offset * 60 * 1000); // Adjust time to local
        return localTime.toISOString(); // Remove 'Z' to reflect local time
    }

    return (
        <div>
            <Modal header={"Filter"} contentStyle={{ width: "730px", height: "auto",minHeight:"300px" }} headingStyle={{ fontSize: "18px", fontWeight: 600, }} headerContainerStyle={{ padding: "20px" }} open={open} onClose={onClose}  >
                {loading ? <LoaderComponent /> :
                    <>
                        <div style={{ padding: "20px 30px", display: "flex", flexDirection: "column", width: "100%", gap: "20px" }}>
                            {/* Date Filter Section */}
                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%", gap: "10%" }}>
                                <DateTimePicker
                                    title="From"
                                    hideNxt={new Date()}
                                    minTime={new Date().setHours(0, 0, 0, 0)}
                                    maxTime={new Date().setHours(23, 59)}
                                    selectedDateTime={usersFilter.fromDate}
                                    onChange={(date) => {
                                        date=new Date(date).setHours(0,0,0,0);
                                        const localISOString = new Date(date).toISOString();
                                        
                                        handleFilterChange({
                                            ...usersFilter,
                                            // fromDate: new Date(date).toISOString()
                                            fromDate: localISOString
                                        });
                                    }}
                                    containerWidth={"144px"}
                                />
                                <DateTimePicker
                                    title="To"
                                    hidePrev={usersFilter.fromDate}
                                    selectedDateTime={usersFilter.toDate}
                                    minTime={new Date(usersFilter?.fromDate).toDateString() === new Date(usersFilter?.toDate).toDateString()
                                        ? new Date(new Date(usersFilter.fromDate).setMinutes(new Date(usersFilter.fromDate).getMinutes() + 1))
                                        : new Date().setHours(0, 0, 0, 0)}
                                    maxTime={new Date().setHours(23, 59)}
                                    onChange={(date) => {
                                        date = new Date(date);
                                        date.setHours(23, 59);
                                        if (new Date(usersFilter.fromDate) < new Date(date)) {
                                            handleFilterChange({
                                                ...usersFilter,
                                                toDate: new Date(date).toISOString()
                                            });
                                        } else {
                                            let toDate = usersFilter.toDate ? new Date(usersFilter.toDate).setHours(23, 59) : new Date().setHours(23, 59)
                                            handleFilterChange({
                                                ...usersFilter,
                                                toDate: new Date(toDate).toISOString()
                                            })
                                        }
                                    }}
                                    isDisable={!(usersFilter.fromDate)}
                                    containerWidth={"144px"}
                                    toMinDate={usersFilter.fromDate}
                                />
                            </div>

                        </div>

             <div className='mt-[20px] w-[50%] max-h-[200px] px-6 '>
                <div style={{ fontSize: "16px", fontWeight: 500, display: "flex",alignItems:"center" ,marginBottom:"8px"}}>
                    <span>States</span>
                       <input
                        style={{ width: "100%",padding:"5px 8px",outline:"none", margin: "0 2px 0 4%", borderRadius: "3px", border: "1px solid #d9d9d9", color: "#3B3B3B", fontSize: "13px"}}
                        type="text"
                        placeholder="Search state here..."
                        onChange={(e) => {
                          e.preventDefault();
                          setSearchQuery(e.target.value)
                        }} />
                </div>
                   <div
                     className='
                     max-h-[250px] 
                     overflow-y-scroll 
                     overflow-x-hidden 
                     text-[14px] 
                     flex 
                     flex-col 
                     gap-[8px] 
                     text-[#3B3B3B]
                     py-2
                     transition-all
                     delay-150
                     '
                    >
                      {(searchQuery ? INDIAN_STATES.filter(s => s.toLowerCase().includes(searchQuery.toLowerCase())) : INDIAN_STATES).map((key) => {
                        return (
                          <SingleFilter
                            isChecked={usersFilter?.states?.includes(key)}
                            onChange={handleOnChangeState}
                            value={key}
                            title={key}
                          />
                        );
                      })}
                    </div>
                </div>

                        <div style={{ display: "flex", justifyContent: "space-between", padding: "20px 25px", marginTop: "100px", alignItems: "center", height: '60px', gap: "20px", borderTop: "1px solid rgba(191, 200, 217, 0.5)" }}>
                            <div
                                onClick={async () => {
                                    setUsersFilter({
                                        fromDate: null,
                                        toDate: null,
                                        states:[]
                                    })
                                    onFilterChange({
                                        fromDate: null,
                                        toDate: null,
                                        states:[],
                                    })
                                }} style={{ width: "60px", height: "38px", color: GLOBAL_STYLES.BG_ACTIVE, fontWeight: 600, fontSize: "14px", cursor: 'pointer', display: "flex", alignItems: "center", justifyContent: "start" }}>
                                Clear all
                            </div>
                            <Button
                                text={"Apply"}
                                style={{ width: "66px", height: "38px", fontSize: "15px" }}
                                onClick={() => {
                                    onFilterChange(usersFilter)
                                    setSearchQuery("");
                                    setOpenFilter(false);
                                }}
                            />
                        </div>
                    </>
                }

            </Modal>
            {

                <Button
                    innerClassName={"filter-btn-inner"}
                    iconStyle={{ width: "18px", marginRight: "10px" }}
                    text={"Filter"}
                    className={"filter-btn"}
                    icon={Filter}
                    onClick={() => {
                        setOpenFilter(true)
                    }}
                    textClassName={"user-details-filter-text"}
                />

            }
        </div>
    )
}

export default UsersFilter